const endPoint = "https://graduation-project-23.herokuapp.com/";

export default endPoint;
